<ng-container *ngIf="promotionVm$ | async as vm">
  @if (showShareDialog) {
    <app-referrals-dialog-share
      [vm]="vm"
      [inviteText]="inviteText"
      (referralShare)="onReferralShare($event)"
      (closeShare)="onCloseShare()"
    ></app-referrals-dialog-share>
  }

  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-5 flex-col-md-7 flex-col-sm-12">
        <div class="referrals">
          <app-account-promotion
            [vm]="vm"
            (copyToClipboard)="onCopyToClipboard($event)"
            (inviteFriends)="onInviteFriends($event)"
            (showPromotionsModal)="showPromotionsModal()"
          >
          </app-account-promotion>
        </div>
      </div>
    </div>
  </div>
</ng-container>

